module.exports = __webpack_public_path__ + "static/media/banner_01.5441f0c5.png";